export const METAMASK = 'METAMASK'
export const WALLETCONNECT = 'WALLETCONNECT'
